// extracted by mini-css-extract-plugin
module.exports = {"main":"Layouts_main__2DSfE"};